import React from 'react';

import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';

const {title, description} = translations['pt-br'].publicFlow.signIn.b2bAlert;

export function AlertB2B() {
	return (
		<AlertInfo.Root severity="warning">
			<AlertInfo.Title title={title} />
			<AlertInfo.Description>{description}</AlertInfo.Description>
		</AlertInfo.Root>
	);
}
